export class Option {
  value: string;
  label: string;

  constructor(label: string, value: string) {
    this.label = label;
    this.value = value;
  }
}
